import { ObjectValues } from "types";

// Maps to DeploymentStatusEnum on the backend
export const QuestionDeploymentStatus = {
  COMPLETED: "done",
  LIVE: "live",
  NOT_DEPLOYED: "not_deployed",
  SCHEDULED: "scheduled",
} as const;

export const questionDeploymentText = {
  [QuestionDeploymentStatus.COMPLETED]: "Completed",
  [QuestionDeploymentStatus.LIVE]: "Currently Live",
  [QuestionDeploymentStatus.NOT_DEPLOYED]: "Not Deployed",
  [QuestionDeploymentStatus.SCHEDULED]: "Scheduled",
};

export type QuestionDeploymentStatusType = ObjectValues<typeof QuestionDeploymentStatus>;

export const getDeploymentStatusText = (status: QuestionDeploymentStatusType) => questionDeploymentText[status] ?? null;
